class Report {
    strategy() {
        return _.get(window.slurp, 'report.strategy');
    }

    pgsqlStrategy(report) {
        return this.strategy()[report] === 'pgsql';
    }
}

const ReportInstance = new Report();

export default ReportInstance;
